import CustomInput from "../../../../components/UI/PageInput/CustomInput";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import DateInput from "../../../../components/UI/PageInput/DateInput";
import {
  aadharNumberValidation,
  panNumberValidation,
  phoneValidation,
  positiveNumberValidation,
} from "../../../../validations/formValidations";

const PersonalInfo = ({
  userSetup,
  register,
  errors,
  setValue,
  control,
  watch,
}) => {
  const { dob, genderId, dateOfJoining } = watch();
  return (
    <div className="halfCol pr-1">
      <div className="userInfoWrap">
        <h4 className="userInfoHeading">Personal Info</h4>
        <div className="px-4 py-6">
          <div className="flex gap-2">
            <div className="w-full">
              <CustomInput
                type="text"
                name="fullName"
                labelText="Full Name"
                placeholder="Enter"
                register={{
                  ...register("fullName", { required: "Please Enter a name" }),
                }}
                error={errors.fullName}
              />
            </div>
            <div className="w-full">
              <DateInput
                label="Date of birth"
                name={"dob"}
                value={dob}
                setValue={setValue}
                register={{
                  ...register("dob", {
                    required: "Please Enter date of birth",
                  }),
                }}
                error={errors.dob}
                disableCurrentAndFutureDays={true}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-full">
              <CustomInput
                type="number"
                name="salary"
                labelText="Salary"
                placeholder="Enter"
                register={{
                  ...register("salary", {
                    required: "Please Enter a salary",
                    ...positiveNumberValidation,
                  }),
                }}
                error={errors.salary}
              />
            </div>
            <div className="w-full">
              <SearchDropdown
                name="genderId"
                label="Gender"
                keyName="name"
                id="id"
                options={userSetup.genders}
                control={control}
                setValue={setValue}
                error={errors.genderId}
                selectedVal={genderId}
                disableValidationMessage={true}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-full">
              <CustomInput
                type="text"
                name="mobile"
                labelText="Phone No."
                placeholder="Enter"
                register={{
                  ...register("mobile", {
                    required: "Please Enter phone no.",
                    ...phoneValidation,
                  }),
                }}
                error={errors.mobile}
              />
            </div>
            <div className="w-full">
              <CustomInput
                type="text"
                name="altPhoneNumber"
                labelText="Alternate Phone No"
                placeholder="Enter"
                register={{
                  ...register("altPhoneNumber", {
                    ...phoneValidation,
                  }),
                }}
                error={errors.altPhoneNumber}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-full">
              {" "}
              <DateInput
                label="Date of Joining *"
                name={"dateOfJoining"}
                value={dateOfJoining}
                setValue={setValue}
                register={{
                  ...register("dateOfJoining", {
                    required: "Please Select date of birth",
                  }),
                }}
                error={errors.dateOfJoining}
                disableCurrentAndFutureDays={true}
              />
            </div>
            <div className="w-full">
              {" "}
              <CustomInput
                type="text"
                name="bikeRegNumber"
                labelText="Bike Registration Number"
                placeholder="Enter"
                register={{
                  ...register("bikeRegNumber"),
                }}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-full">
              <CustomInput
                type="text"
                name="aadharCardNumber"
                labelText="Aadhar Card Number"
                placeholder="Enter"
                register={{
                  ...register("aadharCardNumber", aadharNumberValidation),
                }}
                error={errors.aadharCardNumber}
              />
            </div>
            <div className="w-full">
              <CustomInput
                type="text"
                name="panCardNumber"
                labelText="Pan Card Number  *"
                placeholder="Enter"
                register={{
                  ...register("panCardNumber", {
                    required: "Enter",
                    ...panNumberValidation,
                  }),
                }}
                error={errors.panCardNumber}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PersonalInfo;
